import { render, staticRenderFns } from "./AdminEditClientContact.vue?vue&type=template&id=181f8b16"
import script from "./AdminEditClientContact.vue?vue&type=script&lang=js"
export * from "./AdminEditClientContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports